import http from "./httpService";

const endPoint = "/api/v1/Auth";

export async function login(username, password) {
    return await http.post(`${endPoint}/Login`, { username, password });
}

export default { login };


// WEBPACK FOOTER //
// ./src/services/authService.js